import React, { useState, useEffect } from 'react';
import { MatrixQuestion } from '../../survey-tools/likert-scales';
import { shuffleArray } from '../../survey-tools/shuffle-and-sample'; // Import shuffleArray
import { Button } from '@mui/material';
import { connect } from 'react-redux';
import { nextTask } from '../../study-logic/study-redux-slice';
import {PageContainer} from "../../survey-tools/ui-components/containers"
import { Typography} from "@mui/material";
import {CustomConfirmationDialog} from '../../survey-tools/custom-dialogue'; // Adjust the import path as needed

function UCLALoneliness({ instanceId,nextTask }) {
    const [shuffledStatements, setShuffledStatements] = useState([]);
    const [showDialog, setShowDialog] = useState(false);

    useEffect(() => {
        const statements = [
        "I lack companionship.",
        "There is no one I can turn to.",
        "I am unhappy being so withdrawn.",
        "I feel left out.",
        "I feel isolated from others.",
        "People are around me but not with me.",
        "I am an outgoing person.",
        "I can find companionship when I want it."

    ];
        setShuffledStatements(shuffleArray(statements));
    }, []); // Empty dependency array to only run once on mount
    
    const [responses, setResponses] = useState(Array(8).fill(-99)); 

    const options = ["I never feel this way", "I rarely feel this way", "I sometimes feel this way", "I often feel this way"];

    const statementKeyMap = {
    "I lack companionship.": "UCLA_1",
    "There is no one I can turn to.": "UCLA_2",
    "I am unhappy being so withdrawn.": "UCLA_3",
    "I feel left out.": "UCLA_4",
    "I feel isolated from others.": "UCLA_5",
    "People are around me but not with me.": "UCLA_6",
    "I am an outgoing person.": "UCLA_7",
    "I can find companionship when I want it.": "UCLA_8"

};

    const handleNextClick = () => {
        const isComplete = responses.every(val => val !== -99);
            if (!isComplete) {
                setShowDialog(true); // Show confirmation dialog if not complete
                console.log(responses)
            } else {
                const lonelinessRatings = {};
                shuffledStatements.forEach((statement, index) => {
                    const key = statementKeyMap[statement];
                    lonelinessRatings[key] = responses[index];
                });

        nextTask({ data: { loneliness: lonelinessRatings } });
            console.log(lonelinessRatings)
            }
        }

    return (
        <PageContainer>
        <div>
            <MatrixQuestion
                title=<Typography gutterBottom>Please indicate how often each of the states below is descriptive of you.</Typography>
                rows={shuffledStatements}
                columns={options}
                handleUpdate={(data) => setResponses(data)}
            />
        </div>

        <div>

            <Button variant="contained" onClick={handleNextClick}>Next</Button>

            <CustomConfirmationDialog
    open={showDialog}
    onClose={() => setShowDialog(false)}
    onConfirm={() => {
        setShowDialog(false);
        const lonelinessRatings = {};
                shuffledStatements.forEach((statement, index) => {
                    const key = statementKeyMap[statement];
                    lonelinessRatings[key] = responses[index];
                });

        nextTask({ data: { loneliness: lonelinessRatings } });
            console.log(lonelinessRatings)
            }}
/>
            
        </div>
        </PageContainer>

    );
};

const mapDispatchToProps = { nextTask };
export default connect(null, mapDispatchToProps)(UCLALoneliness);
